import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from '../header/header.component';
import { Router } from '@angular/router';
import { CebWizardHeaderComponent } from '../components/ceb-wizard-header/ceb-wizard-header.component';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.page.html',
  styleUrls: ['./layout.page.scss'],
  imports: [SharedModule, RouterOutlet, HeaderComponent, CebWizardHeaderComponent],
})
export class LayoutPage {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  useCebWizardShell(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return !this.authService.isManager() && /\/(simulation\/|application\/|cncs-wizard\/|cncs\/application\/|ssdg\/application\/|msdg\/application\/|agrivoltaic-one\/application\/|agrivoltaic-two\/application\/|forbidden$)/.test(path);
  }
}
